import {addScrollableSelector, addFillGapSelector} from 'scroll-lock';
const initScrollLock = function() {
	// Selectors which should be scrollable all the time
	addScrollableSelector( '.productcarousel__list' );
	addScrollableSelector( '.mdl_search__suggestions-searchterms' );
	addScrollableSelector( '.mdl_search__suggestions-products' );

	// Fills the gap of that selectors (with fixed positioning - no jumping)
	addFillGapSelector( '.mdl_header__bar' );
	addFillGapSelector( '.mdl_servicerow' );
}

export {
	initScrollLock
}
